import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Plus, Edit, Trash2 } from "lucide-react";
import CurrencyModal from "./CurrencyModal";
import "./CurrencyPairs.css";
import { BACKEND_API } from "../../Utils/Constants";
import { getLocalStorageItem } from "../../Utils/Helper";
import {
  fetchCurrencyPairs,
  addCurrencyPair,
  updateCurrencyPair,
  deleteCurrencyPair,
} from "../../Redux/Action/transaction/currencyPairsAction";

const CurrencyPairs = () => {
  const dispatch = useDispatch();
  const { pairs, loading } = useSelector((state) => state.CurrencyPairs);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    base: "",
    quote: "",
    rate: "",
    _id: null,
  });

  // ✅ Fetch all currency pairs
  const fetchPairs = () => {
    const whitelabelData = getLocalStorageItem("whitelabelData");
    const whitelabelId = whitelabelData?._id;
    
    if (whitelabelId) {
      dispatch(fetchCurrencyPairs({ whitelabelId }));
    } else {
      dispatch(fetchCurrencyPairs());
    }
  };

  useEffect(() => {
    fetchPairs();
  }, []);

  // ✅ Open Add Modal
  const handleAdd = () => {
    setFormData({ base: "", quote: "", rate: "" });
    setIsEditing(false);
    setIsModalOpen(true);
  };

  // ✅ Edit Existing Pair
  const handleEdit = (pair) => {
    setFormData(pair);
    setIsEditing(true);
    setIsModalOpen(true);
  };

  // ✅ Delete Pair
  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this currency pair?"))
      return;
    
    const whitelabelData = getLocalStorageItem("whitelabelData");
    const whitelabelId = whitelabelData?._id;
    
    const payload = { id };
    if (whitelabelId) {
      payload.whitelabelId = whitelabelId;
    }
    
    dispatch(deleteCurrencyPair(payload));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Form validation
    const { base, quote, rate } = formData;
    
    if (!base || !quote || !rate) {
      console.error("❌ All fields are required");
      return;
    }
    
    if (isNaN(rate) || parseFloat(rate) <= 0) {
      console.error("❌ Rate must be a positive number");
      return;
    }
    
    const pair = `${base}${quote}`.toUpperCase();
    const whitelabelData = getLocalStorageItem("whitelabelData");
    const whitelabelId = whitelabelData?._id;
     console.log("whitelabelId",whitelabelId)
    
    if (!whitelabelId) {
      console.error("❌ Whitelabel ID not found");
      return;
    }
    
    try {
      const payload = { 
        base: base.toUpperCase(), 
        quote: quote.toUpperCase(), 
        rate: parseFloat(rate), 
        pair,
        whitelabelId
      };

      if (isEditing) {
        dispatch(updateCurrencyPair({ ...payload, _id: formData._id }));
      } else {
        dispatch(addCurrencyPair(payload));
      }

      setIsModalOpen(false);
    } catch (err) {
      console.error("❌ Error saving pair:", err.response || err.message);
    }
  };

  return (
    <div className="currency-page">
      <div className="currency-header">
        <h1>Currency Pairs</h1>
        <button className="add-btn" onClick={handleAdd}>
          <Plus size={18} /> Add New
        </button>
      </div>

      <div className="currency-table-container">
        <table className="currency-table">
          <thead>
            <tr>
              <th>Pair</th>
              <th>Base</th>
              <th>Quote</th>
              <th>Rate</th>
              <th className="center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={5} className="center text-gray">
                  Loading currency pairs...
                </td>
              </tr>
            ) : pairs.length > 0 ? (
              pairs.map((pair) => (
                <tr key={pair._id}>
                  <td>{pair.pair}</td>
                  <td>{pair.base}</td>
                  <td>{pair.quote}</td>
                  <td>{pair.rate}</td>
                  <td className="center actions">
                    <button
                      onClick={() => handleEdit(pair)}
                      className="edit-btn"
                    >
                      <Edit size={16} />
                    </button>
                    <button
                      onClick={() => handleDelete(pair._id)}
                      className="delete-btn"
                    >
                      <Trash2 size={16} />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={5} className="center text-gray">
                  No currency pairs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <CurrencyModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleSubmit}
        isEditing={isEditing}
      />
    </div>
  );
};

export default CurrencyPairs;